module.exports = __webpack_public_path__ + "img/xiaomi13mobile.2a572ce3.png";